var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.20799 11.1816C6.20799 11.1816 6.07839 12.3551 6.20799 12.7271C6.33758 13.0991 6.57972 13.4215 6.90083 13.6497C7.22193 13.8778 7.60608 14.0004 7.99999 14.0004C8.3939 14.0004 8.77805 13.8778 9.09915 13.6497C9.42025 13.4215 9.66239 13.0991 9.79199 12.7271C9.92158 12.3551 9.90934 11.1816 9.90934 11.1816",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 11.1816H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15 11.1818C14.3397 11.1369 13.718 10.8543 13.2501 10.3863C12.7821 9.91832 12.4995 9.29666 12.4545 8.63636V5.45455C12.4545 4.27313 11.9852 3.1401 11.1498 2.30471C10.3144 1.46932 9.18142 1 8 1V1C6.81858 1 5.68555 1.46932 4.85016 2.30471C4.01477 3.1401 3.54545 4.27313 3.54545 5.45455V8.63636C3.50052 9.29666 3.21791 9.91832 2.74994 10.3863C2.28196 10.8543 1.66029 11.1369 1 11.1818",
    stroke: "black",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.42906e35.svg";
export { ForwardRef as ReactComponent };